import {createSlice} from "@reduxjs/toolkit";
import {extraReducers} from "./action";


const initialState = {
    menu: [],
    loadingStatus: 'loaded',

}

const navAdditionalMenuSlice = createSlice({
        name: 'navAdditionalMenu',
        initialState,
        reducers: {
          /*  fetchSort: (state, action) => {
                state.sort = {};
                if (action.payload.direction !== '') {
                    state.sort[action.payload.field] = action.payload.direction
                }
            },*/

        },
        extraReducers: extraReducers
    }
);

const {actions, reducer} = navAdditionalMenuSlice;

export default reducer;

export const {fetchSort} = actions;
